import axios from 'axios'
import { API_URL, CLIENT_ID } from '@/config'
import store from '@/store'
import Vue from 'vue'
import { getStatusText } from 'http-status-codes'
import getHeaders from './headers'

let myGetStatusText = status => {
  if (status === 204) {
    return 'OK'
  }
  return getStatusText(status)
}

// Setup base config. API endpoint and auth headers
const instance = axios.create({
  baseURL: API_URL,
  headers: getHeaders()
})

instance.reloadHeaders = () => {
  instance.defaults.headers = getHeaders()
}

instance.interceptors.request.use(request => {
  if ((new Date()).getTime() + 60000 > store.getters['auth/tokens'].expires_in) {
    return new Promise((resolve, reject) => {
      var newWindow = window.open(
        `${API_URL}auth?client_id=${CLIENT_ID}&redirect_uri=${window.location.origin}/login&response_type=token`,
        'Login',
        'height=600, width=450'
      )

      if (newWindow) {
        newWindow.focus()
        window.addEventListener('message', function (e) {
          if (e.data.source !== 'login-token') {
            return
          }
          store.commit('auth/SET', e.data.payload)
          instance.reloadHeaders()
          request.headers = instance.defaults.headers
          resolve(request)
        })
      } else {
        resolve(request)
      }
    })
  }
  return request
})

// Catch some 4xx and 5xx errors
instance.interceptors.response.use((response) => {
  if (response.config.method !== 'get') {
    Vue.toasted.showSuccess(myGetStatusText(response.request.status))
  }
  return response
}, (error) => {
  if (!error.request) {
    error.request = {
      status: 200
    }
  }
  if (!error.response) {
    error.response = {
      data: ''
    }
  }
  var errors = [{
    message: myGetStatusText(error.request.status)
  }]
  if (error.request.status !== 404 && error.request.status !== 403 && error.response.data && error.response.data.length > 0) {
    errors = error.response.data
  }
  errors.forEach(error => {
    Vue.toasted.showError(error.message)
  })
  return Promise.reject(error)
})

export default instance
